<template>
  <div class="menu-management">
    <SimpleTable
      ref="leftTable"
      table-code="menuManagement"
      :menus="['插入', '插入下级', '查询', '批量修改', '批量删除']"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, addCbFn } from '@/utils/index'

export default {
  name: 'MenuManagement',
  components: {
    SimpleTable
  },
  data() {
    return {
      // 页面数据
      columns: [
        {
          field: 'name',
          title: '菜单名称',
          tree: true,
          canEdit: true,
          canModify: true
        },
        { field: 'code', title: '菜单编码', canEdit: true, canModify: true },
        { field: 'orderNum', title: '排序', canEdit: true, canModify: true },
        {
          field: 'showFlag',
          title: '是否显示',
          cellType: 'checkbox',
          type: 'switch',
          multiple: true,
          canEdit: true,
          canModify: true
        },
        {
          field: 'remark',
          title: '备注',
          canEdit: true,
          canModify: true
        }
      ],
      tableData: [],
      loading: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTable()
    },
    async getTable() {
      this.tableData = []
      this.loading = true
      const res = await this.$serviceAdmin.get('/sys/menu/list', {
        type: 1
      })
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },
    async onModifyDataChange(getModifyData, cleanModifyData) {
      addCbFn(
        this.$serviceAdmin,
        '/sys/menu/save',
        getModifyData,
        cleanModifyData
      )
    }
  }
}
</script>

<style scoped>
.menu-management {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
</style>
